import React, { useState } from "react";
import { addDoc, collection, getFirestore, getDocs } from "firebase/firestore";
import "../Admin.css";
import TextEditor from "./TextEditor";
import Menu from "../Menu/Menu";
import { useUsersContext } from "../../Context/UsersContext";
import LoaderAdmin from "../LoaderAdmin";
export default function NewArticleCont() {
  const db = getFirestore();
  const [adding, setAdding] = useState(false);
  const [added, setAdded] = useState(false);
  const { loggedData } = useUsersContext();
  const [savingDraft, setSavingDraft] = useState(false);
  const [savedDraft, setSavedDraft] = useState(false);

  const publish = async (a) => {
    setAdding(true);
    try {
      sessionStorage.setItem("articleDraft", JSON.stringify(a));
      const queryCollection = collection(db, `articles`);
      addDoc(queryCollection, a)
        .then((res) => console.log("res"))
        .then(setAdding(false))
        .then(setAdded(true))
        .finally(setTimeout(() => {
          window.location.reload()
        }, 2000))
        .catch((err) => console.log("err"));
    } catch (error) {
      console.error("Ocurrió un error durante la subida:", error);
      setAdding(false);
    }
  };

  const saveDraft = async (a) => {
    setSavingDraft(true);

    try {
      sessionStorage.setItem("articleDraft", JSON.stringify(a));
      const queryCollection = collection(db, `articles`);
      addDoc(queryCollection, a)
        .then((res) => console.log("res"))
        .then(setSavingDraft(false))
        .then(setSavedDraft(true))
        .catch((err) => console.log("err"));
    } catch (error) {
      console.error("Ocurrió un error durante la subida:", error);
      setSavingDraft(false);
    }
  };

  return (
    <div className="admin-section-cont">
 


      {loggedData ? (
        <>
     <Menu />
      <div className="w85 position-relative">
        <TextEditor
          publish={publish}
          saveDraft={saveDraft}
          savingDraft={savingDraft}
          savedDraft={savedDraft}
          adding={adding}
          added={added}
        />
      </div>
        </>
      ) : (
        <LoaderAdmin loggedData={loggedData} />
      )}
    </div>
  );
}
